export default function mini_contact_form() {

    const miniContactForm = document.querySelector('.mini_contact_form');
    const contactFormToggler = document.querySelectorAll('[data-action="close-contact-form"]');
    const submitButton = document.getElementById('send-request-mini');

    if (!miniContactForm && contactFormToggler?.length === 0 && !submitButton) {
        return
    }

    calcMiniFormPosition();
    window.addEventListener('resize', calcMiniFormPosition);

    function calcMiniFormPosition() {
        if (window.innerWidth > 1308) {
            const right = (window.innerWidth - 1308) / 2;
            miniContactForm.style.right = right + 32 + 'px';
        } else if (window.innerWidth > 960) {
            miniContactForm.style.right = '40px';
        } else if (window.innerWidth > 768) {
            miniContactForm.style.right = '40px';
        } else if (window.innerWidth > 480) {
            miniContactForm.style.right = '24px';
        } else {
            miniContactForm.style.right = '20px';
        }
    }

    contactFormToggler.forEach(element => {
        element.addEventListener('click', () => {
            miniContactForm.classList.toggle('open');
        });
    });

    submitButton.addEventListener('click', (e) => {
        e.preventDefault();

        const form = e.target.closest('form');
        const nameInput = form.querySelector('input[name="name"]');
        const name = form.querySelector('input[name="name"]').value;
        const phoneInput = form.querySelector('input[name="phone"]');
        const phone = form.querySelector('input[name="phone"]').value;

        nameInput.parentElement.classList.remove('error');
        phoneInput.parentElement.classList.remove('error');

        if (!name || !phone) {
            if (!name) {
                nameInput.parentElement.classList.add('error');
            }
            if (!phone) {
                phoneInput.parentElement.classList.add('error');
            }
            return;
        }

        fetch('/post-feedback', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                name: name,
                phone: phone
            })
        })
            .then(response => response.json())
            .then(response => {
                console.log(response)
                if (response.result && response.result.length > 0) {
                    // Handle validation errors
                    response.result.forEach(error => {
                        const input = document.querySelector(`input[name="${error.field}"]`);
                        if (input) {
                            input.parentElement.classList.add('error');
                        }
                    });
                } else {
                    miniContactForm.querySelector('.form_succes').classList.remove('hidden');

                    setTimeout(() => {
                        miniContactForm.querySelector('.form_succes').classList.add('hidden');
                        miniContactForm.classList.remove('open');
                        document.querySelector('body').classList.remove('menu_open');

                        form.querySelector('input[name="name"]').value = '';
                        form.querySelector('input[name="phone"]').value = '';
                    }, 5000);
                }
            })
            .catch(() => {
                alert('An error occurred. Please try again later.');
            });
    })
}
